import { Navigate } from 'react-router-dom';
import { SETTINGS_ACCESS } from './settings-paths';

/** Редирект со старого /settings на раздел «Доступы». */
export function SettingsHomePage() {
  return <Navigate to={SETTINGS_ACCESS} replace />;
}
